export enum MediaTypeEum {
  image = "image",
  video = "video",
  text = "text",
  voice = "voice",
  audio = "audio",
}
